<header>
  <h2 style="padding-right: 50px">Información del siniestro</h2>
  <span style="flex: 1 1 auto;"></span>
  <button
    id="btnCerrar"
    mat-icon-button
    (click)="onClose()">
    X
  </button>
</header>
<mat-dialog-content >
  <form [formGroup]="form">
    <fieldset>
    <label class="full-width">
      Lugar de ocurrencia<br>
      <input type="text" matInput formControlName="lugar">
    </label>
    <label class="full-width">
      ¿Cómo ha ocurrido?<br>
      <input type="text" matInput formControlName="como">
    </label>
  </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="center" style="margin-bottom: 20px; margin-top:5px;">
  <button
    style="width: 30%;"
    type="button"
    class="btnCCNewOscuro"
    mat-flat-button
    (click)="guardar()"
    [disabled]="form.invalid">
    Guardar
  </button>
</mat-dialog-actions>